// @flow
import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { qualifyLinksForWcag } from 'Utils/link';
const cx = classNames.bind(styles);

const RichText = ({ className, content, hasDarkBackground, e2e }) => {
  content = qualifyLinksForWcag(content);

  return (
    <div
      className={cx(className, styles.root, {
        [styles.hasDarkBackground]: hasDarkBackground,
      })}
      dangerouslySetInnerHTML={{ __html: content }}
      data-has-dark-background={hasDarkBackground}
      data-e2e={e2e}
    />
  );
};

RichText.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  hasDarkBackground: PropTypes.bool,
};

export default RichText;
